import script from "./kalio-company-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./kalio-company-list.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__